<template>
<div :class="cssLoginBg">
    <div class="topDiv"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
        <h3 class="title">移动物联卡综合管理系统</h3>
        <el-form-item prop="account">
            <el-input type="text" v-model="ruleForm.account" auto-complete="off" placeholder="账号" @keyup.enter.native="handleSubmit"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" auto-complete="off" placeholder="密码" @keyup.enter.native="handleSubmit"></el-input>
        </el-form-item>
        <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">登录</el-button>
            <!--<el-button @click.native.prevent="handleReset">重置</el-button>-->
        </el-form-item>
    </el-form>
    <div class="footer">Copyright © 2017-2023 {{this.filingsCompany}} All Rights Reserved.<a href="https://beian.miit.gov.cn/" target="_blank">{{this.filings}}</a></div>
</div>
</template>

<script>
import util from '../common/js/util'
import {
    requestLogin,
    getLoginValidcodeStatusinfo
} from '../api/api';
var oScript = document.createElement('script');
oScript.src = "https://ssl.captcha.qq.com/TCaptcha.js";
document.getElementsByTagName('body')[0].appendChild(oScript);
export default {
    data() {
        return {
            logining: false,
            cssLoginBg:"loginDiv_putong",
            validcode: {
                enabled: false,
                appid: ''
            },
            ruleForm: {
                account: '',
                checkPass: ''
            },
            rules: {
                account: [{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur'
                }],
                checkPass: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }]
            },
            checked: true,
            filings: '豫ICP备17018570号',
            filingsCompany: 'YUNKA',
        };
    },
    mounted() {
        if(location.origin.indexOf('sim.cxgps.com') != -1){
            this.filings = '粤ICP备14100635号';
            this.filingsCompany = 'CHANGXING';
        }

        if(util.formatDate.format(new Date(),'yyyyMMdd') == (new Date().getFullYear()+"0918")){
            //九一八事变国耻哀悼纪念日全网灰色
            document.documentElement.style.filter="grayscale(1)";            
        }else if( (util.formatDate.format(new Date(),'yyyyMMdd') >= (new Date().getFullYear()+"0928")) && (util.formatDate.format(new Date(),'yyyyMMdd') <= (new Date().getFullYear()+"1008")) ){
            //庆祝国庆节放假
            this.cssLoginBg="loginDiv_guoqing";
        }

        getLoginValidcodeStatusinfo({}).then(res => {
            let {
                msg,
                code,
                data
            } = res;
            if (code !== 0) {
                this.$message({
                    message: msg,
                    type: 'error'
                });
            } else {
                if (data != null) {
                    this.validcode.enabled = true;
                    this.validcode.appid = data.appid;
                }
            }
        });
    },
    methods: {
        userloginMethod(loginParams) {
            console.log("验证成功登录");
            // 用户验证成功,获取到ticket，然后你需要将这个ticket和之前的businessId一起传给后台
            // 若后台验证成功，用户就可以收到验证码了，无需你再做其他操作
            this.logining = true;
            //NProgress.start();
            requestLogin(loginParams).then(res => {
                this.logining = false;
                //NProgress.done();
                let {
                    msg,
                    code
                } = res;
                this.validateflag = true;
                if (code !== 0) {
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                } else {
                    let user = res.data;
                    //设置用户的SESSIONID
                    //从本地COOKIE中取JSESSIONID对应的值
                    var sessionName = "JSESSIONID";
                    var sessionTmpVal = window.document.cookie.match('(^|;) ?' + sessionName + '=([^;]*)(;|$)');
                    var currentSessionId = sessionTmpVal ? sessionTmpVal[2] : null;
                    console.log("刚登陆currentSessionId:" + currentSessionId);
                    user.sessionid = currentSessionId;
                    sessionStorage.setItem('user', JSON.stringify(user));
                    this.$router.push({
                        path: '/main'
                    });
                }
            });
        },
        handleReset() {
            this.$refs.ruleForm.resetFields();
        },
        callback_TencentCaptcha(res) {
            console.log("登录");
            if (res.ret == 0) {
                var loginParams = {
                    username: this.ruleForm.account,
                    password: this.ruleForm.checkPass,
                    "ticket": res.ticket,
                    "randstr": res.randstr
                };
                this.userloginMethod(loginParams);
            }
        },
        handleSubmit(ev) {
            var _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (this.validcode.enabled) {
                        var captcha = new TencentCaptcha(this.validcode.appid, this.callback_TencentCaptcha);
                        captcha.show(); // 显示验证码
                    } else {
                        var loginParams = {
                            username: this.ruleForm.account,
                            password: this.ruleForm.checkPass
                        };
                        this.userloginMethod(loginParams);
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.loginDiv {
    width: 100%;
    height: 100%;
    //background:url(../assets/bg.jpg) #7EA0C3 bottom repeat-x;
    background: url(../assets/bg.jpg) #FFF;
    background-size: 100% auto;
    background-repeat: repeat-x;

    .topDiv {
        height: 200px;
    }
}

.title {
    cursor: default;
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 28px;
	text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);
}

/* 普通登录背景 */
.loginDiv_putong {
    width: 100%;
    height: 100%;
    background: url(../assets/holidayBg/putong.jpg) bottom #FFF;
    background-size: 100% auto;
    background-repeat: repeat-x repeat-y;

    .topDiv {
        height: 230px;
    }

    .login-container{
        margin-right:280px;
    }

    .footer {
        color: #FFF;
    }
    .footer a:link {
        color: #FFF;
    }
    .footer a:visited {
        color: #FFF;
    }
}

/* 国庆节登录背景 */
.loginDiv_guoqing {
    width: 100%;
    height: 100%;
    background: url(../assets/holidayBg/guoqing.jpg) #FFF;
    background-size: 100% auto;
    background-repeat: repeat-x;

    .topDiv {
        height: 200px;
    }

    .login-container{
        margin-top:100px;
    }

    .footer {
        color: #FFF;
    }
    .footer a:link {
        color: #FFF;
    }
    .footer a:visited {
        color: #FFF;
    }
}

/* 春节登录背景 */
.loginDiv_chunjie {
    width: 100%;
    height: 100%;
    background: url(../assets/holidayBg/chunjie.jpg) #cc1016;
    background-size: 100% auto;
    background-repeat: repeat-x;

    .topDiv {
        height: 200px;
    }

    .footer {
        color: #FFF;
    }
    .footer a:link {
        color: #FFF;
    }
    .footer a:visited {
        color: #FFF;
    }
}

/* 中秋节登录背景 */
.loginDiv_zhongqiu {
    width: 100%;
    height: 100%;
    background: url(../assets/holidayBg/zhongqiu.jpg) #FFF;
    background-size: 100% auto;
    background-repeat: repeat-x;

    .topDiv {
        height: 230px;
    }

    .login-container{
        margin-right:280px;
    }

}



.login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 0px auto;
    /*中秋和蓝色背景样式
    margin-right:280px;*/
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;



    .remember {
        margin: 0px 0px 35px 0px;
    }
}

.footer {
    height: 30px;
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 0;
    color: #7EA0C3;
}

.footer a:link {
    text-decoration: none;
    color: #7EA0C3;
}

.footer a:hover {
    color: #FFF;
    text-decoration: underline;
}

.footer a:visited {
    color: #7EA0C3;
}
</style>



// WEBPACK FOOTER //
// Login.vue?30722c1b